import { useEffect } from 'react';
import { dateWithTimeZone } from "../../../../../utilities/utils";

const MgidPixel = ({ model }) => {

    useEffect(() => {
        let expirationDate = new Date("2024-09-01");//YYYY-MM-DD

        if( dateWithTimeZone() < expirationDate ) {
            if (model?.name === 'Q5' || model?.name === 'Q3 Sportback') {
                
                if ( document.getElementById('phd-mgdi-pixel-script') !== null || document.getElementById('phd-mgdi-mgsensor-pixel-script') !== null || document.getElementById('phd-mgdi-adclida-pixel-script') !== null) {

                } else {
                    let code        = `(function() {
                        var d = document, w = window;
                        w.MgSensorData = w.MgSensorData || [];
                        w.MgSensorData.push({
                        cid:871822,
                        lng:"us",
                        project: "a.mgid.com"
                        });
                        var l = "a.mgid.com";
                        var n = d.getElementsByTagName("script")[0];
                        var s = d.createElement("script");
                        s.type = "text/javascript";
                        s.async = true;
                        var dt = !Date.now?new Date().valueOf():Date.now();
                        s.src = "https://" + l + "/mgsensor.js?d=" + dt;
                        n.parentNode.insertBefore(s, n);
                    })();`

                    const script    = document.createElement('script');
                    script.type     = "text/javascript";
                    script.id       = "phd-mgdi-pixel-script";
                    script.text     = code;

                    document.body.appendChild(script);


                    let code1        = `(window._mgq = window._mgq || []).push(["MgSensorInvoke","audi-pixel"])`

                    const script1    = document.createElement('script');
                    script1.id       = "phd-mgdi-mgsensor-pixel-script";
                    script1.text     = code1;

                    document.body.appendChild(script1);


                    let code2        = `document.addEventListener('DOMContentLoaded', function() {
                        var links = document.querySelectorAll('a');
                        var urlParams = new URLSearchParams(window.location.search);

                        if (urlParams.toString() === '') {
                            return;
                        }

                        for (var i = 0; i < links.length; i++) {
                            var link = links[i];
                            var linkUrl = link.href;
                            var hashIndex = linkUrl.indexOf('#');
                            var urlWithoutHash = linkUrl;
                            var urlHash = '';

                            if (hashIndex !== -1) {
                                urlWithoutHash = linkUrl.substring(0, hashIndex);
                                urlHash = linkUrl.substring(hashIndex);
                            }

                            var existingParams = new URLSearchParams(urlWithoutHash.split('?')[1]);

                            urlParams.forEach(function(value, key) {
                                if (!existingParams.has(key)) {
                                    existingParams.append(key, value);
                                }
                            });

                            link.href = urlWithoutHash.split('?')[0] + '?' + existingParams.toString() + urlHash;
                        }
                    });`

                    const script2    = document.createElement('script');
                    script2.id       = "phd-mgdi-adclida-pixel-script";
                    script2.text     = code2;

                    document.body.appendChild(script2);
                }
            }
        }
    }, [model]);
    

    return (<></>);
};

export default MgidPixel;